import React from 'react';
type BookCoverProps = {
  kicker: string;
  title: string;
  number?: string;
  accent?: string;
  size?: 'sm' | 'md';
  className?: string;
};

/** Code-drawn cover in the product look: white page, apparatus colour band, level dots. */
export function BookCover({
  kicker,
  title,
  number,
  accent = 'bg-coral',
  size = 'md',
  className = ''
}: BookCoverProps) {
  const sm = size === 'sm';
  return <div className={`relative aspect-[3/4] overflow-hidden rounded-[10px] bg-white shadow-book ${className}`} data-id="element-41" data-mp="2o5wuem96fvy7">
      <span className={`absolute inset-x-0 top-0 h-[22%] ${accent}`} aria-hidden="true" data-id="element-42" data-mp="2jdwyd4w89n6w" />
      <svg viewBox="0 0 120 60" className="absolute bottom-[10%] left-[10%] w-[80%]" aria-hidden="true" data-id="element-43" data-mp="2ef2ahojel8fx">
        <line x1="4" y1="50" x2="116" y2="50" stroke="#E4E8F2" strokeWidth="3" strokeLinecap="round" data-id="element-44" data-mp="29htm367nw868" />
        <path d="M14 48 C 40 6, 80 6, 106 48" stroke="#2541B2" strokeWidth="1.6" strokeDasharray="4 4" fill="none" data-id="element-45" data-mp="24gmiljcjxv5d" />
        <circle cx="14" cy="50" r="3.2" fill="#17B8A6" data-id="element-46" data-mp="20gm1fqy2j5um" />
        <circle cx="60" cy="17" r="3.2" fill="#FFC53D" data-id="element-47" data-mp="19a97tjmrtv80" />
        <circle cx="106" cy="50" r="3.2" fill="#FF5A5F" data-id="element-48" data-mp="198odnv4dceao" />
      </svg>
      <div className="relative flex h-full flex-col px-[11%] pt-[30%]" data-id="element-49" data-mp="1e29gq1ktjygq">
        <p className={`font-display font-bold uppercase tracking-[0.18em] text-slate ${sm ? 'text-[7px]' : 'text-[9px]'}`} data-id="element-50" data-mp="zd3gqbe5q47s">
          {kicker}
        </p>
        {number && <p className={`mt-1 font-display font-extrabold leading-none text-cloud-dark ${sm ? 'text-3xl' : 'text-5xl'}`} data-id="element-51" data-mp="1s193f3oru3a9">{number}</p>}
        <p className={`mt-2 font-display font-extrabold leading-[1.02] tracking-tight text-ink ${sm ? 'text-[13px]' : 'text-[19px]'}`} data-id="element-52" data-mp="1wzajrgutboi1">
          {title}
        </p>
        <p className={`mt-2 font-semibold uppercase tracking-widest text-slate-soft ${sm ? 'text-[5.5px]' : 'text-[7px]'}`} data-id="element-53" data-mp="1n1w8dvnqxpwl">
          Rec Gymnastics Class-Ready
        </p>
      </div>
    </div>;
}